var MultiGeometryViewBase = require('../base/multi-geometry-view-base');
var PolylineView = require('./polyline-view');

var MultiPolygonView = MultiGeometryViewBase.extend({
  GeometryViewClass: PolylineView
});

module.exports = MultiPolygonView;



//////////////////
// WEBPACK FOOTER
// ./~/cartodb.js/src/geo/geometry-views/gmaps/multi-polyline-view.js
// module id = 1539
// module chunks = 6